import React from 'react';
import { Link } from 'react-router-dom';
export default function ErrorPage() {
  return (
    <>
      <section className="error-page">
        <div className="errorpage-content">
          <div className="error-content">
            <h1 className="heading">Oops! We can’t seem to find that page</h1>
            <p>Oops! It looks like the page you’re looking for doesn’t exist or has been moved. <br/>
            Return to Found – Mobility Infotech Logistics to find and continue exploring what you’re looking for.</p>
            <div className="theme-wrapper">
              <Link to={"/"} className="theme-btn"> <span>Go To homepage</span> </Link>
            </div>
            <div className="error-img">
              <img src="/assets/images/error-image.webp" className="img-responsive" alt="Error" />
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
